var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/add-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53488 12.8372C7.07721 12.8372 6.69767 12.4577 6.69767 12C6.69767 11.5423 7.07721 11.1628 7.53488 11.1628H11.1628V7.53488C11.1628 7.07721 11.5423 6.69767 12 6.69767C12.4577 6.69767 12.8372 7.07721 12.8372 7.53488V11.1628H16.4651C16.9228 11.1628 17.3023 11.5423 17.3023 12C17.3023 12.4577 16.9228 12.8372 16.4651 12.8372H12.8372V16.4651C12.8372 16.9228 12.4577 17.3023 12 17.3023C11.5423 17.3023 11.1628 16.9228 11.1628 16.4651V12.8372H7.53488Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.38047 24 0 18.6195 0 12C0 5.38047 5.38047 0 12 0C18.6195 0 24 5.38047 24 12C24 18.6195 18.6195 24 12 24ZM12 1.67442C6.30698 1.67442 1.67442 6.30698 1.67442 12C1.67442 17.693 6.30698 22.3256 12 22.3256C17.693 22.3256 22.3256 17.693 22.3256 12C22.3256 6.30698 17.693 1.67442 12 1.67442Z",
    fill: "inherit"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.47f4bdf26c101ed026b74ddbff555609.svg";
export { ForwardRef as ReactComponent };